import { makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  carboon: {
    display: "inline-block",
    fontWeight: 400,
  },
  power: {
    display: "inline-block",
    fontWeight: 400,
  },
}));

export const LogoText = ({ variant, root, customerName }) => {
  const classes = useStyles();
  return (
    <div className={root}>
      {customerName ? (
        <Typography className={classes.carboon} variant={variant || "h2"}>
          {customerName}
        </Typography>
      ) : (
        <>
          <Typography className={classes.carboon} variant={variant || "h2"}>
            property
          </Typography>
          <Typography className={classes.power} variant={variant || "h2"} color="primary">
            power
          </Typography>
        </>
      )}
    </div>
  );
};
